<template>
  <div>
    <h2>每周班表</h2>
  </div>

  <div class="container" v-viewer="{ movable: false }">
    <ul class="nav nav-tabs" id="nav">
      <li v-for="tab in tabs" v-bind:key="tab" class="nav-item">
        <a
          href="#"
          class="nav-link"
          :class="{ active: tab.isActive }"
          @click="setActive(tab)"
          >{{ tab.name }}</a
        >
      </li>
      <li class="nav-item dropdown">
        <a
          class="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          href="#"
          role="button"
          aria-expanded="false"
          id="DropdownMenu"
          >更多</a
        >
        <ul class="dropdown-menu"></ul>
      </li>
    </ul>
    <div class="tab-content">
      <div
        v-for="tab in tabs"
        v-bind:key="tab"
        class="tab-pane"
        :class="{ active: tab.isActive }"
      >
        <div v-for="value in imagePath" :key="value">
          <img :src="value" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  data() {
    return {
      tabs: [],
      activeTab: {},
      imagePath: [],
    };
  },
  methods: {
    selectAll() {
      axios
        .post("/php/spa_config.php", {
          action: "selectWeek",
        })
        .then((res) => {
          this.tabs = res.data;
          this.setFirst();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.setDropdown("#nav", 50);
        });
    },
    setFirst: function () {
      var tab = this.tabs.find((e) => e.seq == "1");
      tab.isActive = true;

      for (var i = 1; i <= tab.image; i++) {
        var now = new Date();
        now.setDate(now.getDate() - now.getDay());
        //var dpath = now.toLocaleString(undefined, { hour12: false }).split(" ")[0];
        var dpath = now.toISOString().split("T")[0];
        //dpath = dpath.replaceAll("/","-");
        console.log("dpath=" + dpath);

        var day = now.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        var month = now.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var year = now.getFullYear();
        var npath = year + "_" + month + "_" + day;
        console.log("npath=" + npath);
        var path =
          "https://imgf.gg9453.com/images/spa_weekly/" +
          tab.id +
          "/" +
          npath +
          "_" +
          i +
          ".jpg";
        console.log("path=" + path);

        this.imagePath.push(path);
      }
    },
    setActive: function (tab) {
      tab.isActive = true;
      this.activeTab = tab;
      var name = this.activeTab.name;
      this.tabs.forEach(function (tab) {
        if (tab.name !== name) {
          tab.isActive = false;
        }
      });

      this.imagePath.splice(0);

      for (var i = 1; i <= tab.image; i++) {
        var now = new Date();
        now.setDate(now.getDate() - now.getDay());
        var dpath = now.toLocaleString(undefined, { hour12: false }).split(" ")[0];
        dpath = dpath.replaceAll("/", "-");
        console.log("dpath=" + dpath);

        var day = now.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        var month = now.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        var year = now.getFullYear();
        var npath = year + "_" + month + "_" + day;
        console.log("npath=" + npath);
        var path =
          "https://imgf.gg9453.com/images/spa_weekly/" +
          tab.id +
          "/" +
          npath +
          "_" +
          i +
          ".jpg";
        console.log("path=" + path);

        this.imagePath.push(path);
      }
    },
    setDropdown: function (menu, maxHeight) {
      var nav = $(menu);
      var navHeight = nav.innerHeight();
      if (navHeight >= maxHeight) {
        $(menu + " .dropdown").removeClass("d-none");
        $(".navbar-nav").removeClass("w-auto").addClass("w-100");

        while (navHeight > maxHeight) {
          //  add child to dropdown
          var children = nav.children(menu + " li:not(:last-child)");
          var count = children.length;
          $(children[count - 1]).prependTo(menu + " .dropdown-menu");
          navHeight = nav.innerHeight();
        }
        $(".navbar-nav").addClass("w-auto").removeClass("w-100");
      } else {
        var collapsed = $(menu + " .dropdown-menu").children(menu + " li");

        if (collapsed.length === 0) {
          $(menu + " .dropdown").addClass("d-none");
        }

        while (
          navHeight < maxHeight &&
          nav.children(menu + " li").length > 0 &&
          collapsed.length > 0
        ) {
          //  remove child from dropdown
          collapsed = $(menu + " .dropdown-menu").children("li");
          $(collapsed[0]).insertBefore(nav.children(menu + " li:last-child"));
          navHeight = nav.innerHeight();
        }

        if (navHeight > maxHeight) {
          this.setDropdown(menu, maxHeight);
        }
      }
    },
    resizeHandler: function () {
      this.setDropdown("#nav", 50);
    },
  },
  created: function () {
    window.addEventListener("resize", this.resizeHandler);
  },
  unmounted() {
    window.removeEventListener("resize", this.resizeHandler);
  },
  mounted() {
    this.selectAll();
  },
};
</script>
